/**
 * RightBanner — promotional aside shown alongside the main content.
 * Authenticated users keep the promotional content but do not see guest actions.
 * Matches the Figma desktop right-banner card.
 */
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@wlb/shared/context/AuthContext';
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { Button } from '../ui/Button';
import { BrandLogo } from '../ui/BrandLogo';
import bannerHero from '../../assets/images/banner-signup-hero.png';

export function RightBanner() {
  const { isAuthenticated, token } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

  /* Sign-up issues a token but leaves `isAuthenticated` false until
     `completeAuthSession` runs at the end of onboarding, so a member part-way
     through the flow still counts as a guest by that flag alone. Keying off the
     token too stops the onboarding screens offering "Join for free"/"Sign In"
     to someone who has already registered. */
  const isGuest = !isAuthenticated && !token;

  return (
    <aside className="right-banner">
      <div className="right-banner__card">
        <div className="right-banner__copy">
          <BrandLogo compact className="right-banner__logo" />
          <h2 className="right-banner__title">{t('home.rightBanner.title')}</h2>
          <p className="right-banner__subtitle">{t('home.rightBanner.subtitle')}</p>
          {isGuest && (
            <div className="right-banner__actions">
              <Button size="lg" onClick={() => navigate('/signup')}>
                {t('home.rightBanner.joinForFree')}
              </Button>
              <Button size="lg" variant="outline" onClick={() => navigate('/login')}>
                {t('home.rightBanner.signIn')}
              </Button>
            </div>
          )}
        </div>
        <img
          className="right-banner__image"
          src={bannerHero}
          alt=""
          aria-hidden
        />
      </div>
    </aside>
  );
}
